import { BookingStep } from './booking/booking.constants';

export const HASHES = {
  cancellationPolicy: 'cancellation-policy',
  terms: 'terms',
};

export const ROUTES_BASE = {
  home: '/',
  market: '/market',
  experiences: '/experiences',
  experience: '/experience',
  kiosk: '/kiosk',
  filtered: '/filtered',
};

export const ROUTES = {
  home: ROUTES_BASE.home,
  auth: {
    base: '/auth',
    changePassword: {
      base: '/auth/change-password',
      success: '/auth/change-password/success',
    },
  },
  booking: {
    base: (step = ':step') => `/book/${step}`,
    [BookingStep.TIME]: '/book/time',
    [BookingStep.PARTICIPANTS]: '/book/tickets',
    [BookingStep.PAYMENT]: '/book/pay',
    [BookingStep.SUMMARY]: '/book/summary',
  },
  privacy: '/privacy-policy',
  notFound: '/404',
  market: (slug = ':marketSlug') => `${ROUTES_BASE.market}/${slug}`,
  marketExperience: (marketSlug = ':marketSlug', experienceSlug = ':experienceSlug') =>
    `${ROUTES_BASE.experiences}/${marketSlug}/${experienceSlug}`,
  kioskBase: ROUTES_BASE.kiosk,
  kiosk: (slug = ':kioskSlug') => `${ROUTES_BASE.kiosk}/${slug}`,
  kioskExperience: (kioskSlug = ':kioskSlug', experienceSlug = ':experienceSlug') =>
    `/kiosk/${kioskSlug}/experience/${experienceSlug}`,
  cancel: '/cancel',
  account: {
    base: '/account',
    itinerary: '/account/itinerary',
    settings: '/account/settings',
  },
  experiences: '/experiences',
  magazine: '/magazine',
  success: '/success',
  failure: '/failure',
  standalonePolicy: (slug = ':experienceSlug') => `/policy/${slug}`,
  standaloneTerms: '/legal/terms-and-conditions',
  standaloneCookies: '/legal/cookie-policy',
  filtered: ROUTES_BASE.filtered,
};

export const DISABLED_SCROLL_TO_TOP_ROUTES = [
  ROUTES.booking[BookingStep.TIME],
  HASHES.cancellationPolicy,
  HASHES.terms,
];
